// extracted by mini-css-extract-plugin
export default {"validColor":"#44cc94","invalidColor":"#f04d52","voucherContainer":"voucherContainer__26cwe","headerTitle":"headerTitle__1wCad","column":"column__1T6Lv","giftForm":"giftForm__gkbK6","questionButton":"questionButton__3DJkz","submitButton":"submitButton__3X2o2","responseBlock":"responseBlock__1SPrk","fade":"fade__2nnMj","icon":"icon__2oruS","bookButton":"bookButton__dh_FP","tooltip":"tooltip__2QTQm","tooltipContent":"tooltipContent__EEmS-","previousButton":"previousButton__2QiOx"};
    if(module.hot) {
      // 1713425490431
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  